// Identidad oficial RAPIFAST (archivos originales, sin redibujar ni deformar).
// Sistema centralizado de recursos de marca — usar estos componentes, nunca rutas sueltas.
// horizontal: encabezados, navegación, acceso. vertical: bienvenida/portada. icon: compacto, favicon.
const P = process.env.PUBLIC_URL;
export const BRAND = {
  name: "RAPIFAST",
  slogan: "LLEVAMOS LO QUE NECESITAS",
  company: "Transformart",
  horizontal: `${P}/rapifast-horizontal-alpha.png`,
  vertical: `${P}/rapifast-vertical-alpha.png`,
  icon: `${P}/rapifast-icon.png`,
};

// Icono + wordmark compacto (menú lateral, encabezados).
export const Logo = ({ size = 40, withText = true, className = "" }) => {
  if (!withText) {
    return (
      <img
        src={BRAND.icon}
        alt={BRAND.name}
        width={size}
        height={size}
        className={`select-none rounded-xl ${className}`}
        data-testid="brand-logo"
        style={{ objectFit: "contain" }}
      />
    );
  }
  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="brand-logo">
      <img
        src={BRAND.icon}
        alt=""
        width={size}
        height={size}
        className="select-none rounded-xl"
        style={{ objectFit: "contain" }}
      />
      <div className="leading-none">
        <div className="font-heading text-lg font-extrabold italic tracking-tight text-white">
          RAPI
          <span className="bg-gradient-to-r from-[#FF6A00] to-amber-400 bg-clip-text text-transparent">
            FAST
          </span>
        </div>
        <div className="font-heading text-[8px] font-bold uppercase tracking-[0.28em] text-gray-400">
          {BRAND.slogan}
        </div>
      </div>
    </div>
  );
};

// Lockup horizontal oficial (icono + RAPIFAST + eslogan en el arte) con fondo transparente
// (versión técnica alfa derivada del original, sin alterar diseño ni colores).
export const LogoFull = ({ className = "", ...props }) => (
  <img
    src={BRAND.horizontal}
    alt={`${BRAND.name} — ${BRAND.slogan}`}
    className={`select-none ${className}`}
    data-testid="brand-logo-full"
    style={{ objectFit: "contain" }}
    {...props}
  />
);

// Composición vertical oficial (bienvenida, portada, espacios promocionales), fondo transparente.
export const LogoVertical = ({ className = "", ...props }) => (
  <img
    src={BRAND.vertical}
    alt={BRAND.name}
    className={`select-none ${className}`}
    data-testid="brand-logo-vertical"
    style={{ objectFit: "contain" }}
    {...props}
  />
);
